type ToastType = 'error' | 'success';

export interface ToastItem {
  id: string;
  message: string;
  type: ToastType;
}

type Listener = (toasts: ToastItem[]) => void;

let toasts: ToastItem[] = [];
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((l) => l([...toasts]));
}

export const toast = {
  error(message: string) {
    const item: ToastItem = { id: crypto.randomUUID(), message, type: 'error' };
    toasts = [...toasts, item];
    emit();
    setTimeout(() => {
      toasts = toasts.filter((t) => t.id !== item.id);
      emit();
    }, 5000);
  },
  success(message: string) {
    const item: ToastItem = { id: crypto.randomUUID(), message, type: 'success' };
    toasts = [...toasts, item];
    emit();
    setTimeout(() => {
      toasts = toasts.filter((t) => t.id !== item.id);
      emit();
    }, 4000);
  },
  subscribe(fn: Listener) {
    listeners.add(fn);
    fn([...toasts]);
    return () => {
      listeners.delete(fn);
    };
  },
};

/** User-facing message from an API or unknown error. */
export function errorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err && typeof err.message === 'string') {
    return err.message;
  }
  return 'Something went wrong. Please try again.';
}
